import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  MenuItem,
  InputAdornment,
} from "@mui/material";

import SearchIcon from "@mui/icons-material/Search";


export default function PackageManagement() {
  const [packages, setPackages] = useState([]);
  const [statusFilter, setStatusFilter] = useState("");
  const [searchText, setSearchText] = useState("");


  /* --------------------------------
     LOAD PACKAGES (mock / API ready)
  -------------------------------- */
useEffect(() => {
  const mockPackages = Array.from({ length: 10 }).map((_, index) => ({
    id: index + 1,
    name: index % 2 === 0 ? "Starter" : "Professional",
    status: index % 3 === 0 ? "Inactive" : "Active",
    price: 100 + index * 20,
    originalPrice: 500 + index * 50,
    discount: `${50 - index * 2}% OFF`,
    users: 3 + index,
    warehouses: 1 + (index % 3),
    duration: 365,
  }));

  setPackages(mockPackages);
}, []);

const filteredPackages = packages.filter((pkg) => {
  const matchesStatus = statusFilter
    ? pkg.status === statusFilter
    : true;

  const search = searchText.toLowerCase();
  const matchesSearch =
    pkg.name.toLowerCase().includes(search) ||
    pkg.discount.toLowerCase().includes(search);

  return matchesStatus && matchesSearch;
});

  return (
    <Box className="st-page">
      {/* ================= PAGE HEADER ================= */}
      <Box className="st-page-header">
        <Typography component="div" className="st-h1">
          Package Management
        </Typography>
        <Typography component="div" className="st-h2 st-subtitle">
          Create and manage subscription packages
        </Typography>
      </Box>

      {/* ================= MAIN GRID ================= */}
      <Grid container spacing={3}>
        {/* ============== CREATE PACKAGE ============== */}
        <Grid size={{ xs: 12, md: 5 }}>
          <Card className="st-card">
            <CardContent>
              <Typography component="div" className="st-h2">
                Create Package
              </Typography>
              <Typography component="div" className="st-h3 st-muted">
                Define pricing, limits and visibility for your plan
              </Typography>

              <Box className="st-form">

                <TextField
                  label="Package Name"
                  fullWidth
                  size="small"
                />

                <TextField
                  label="Package Tag"
                  fullWidth
                  size="small"
                />

                <TextField
                  label="Price"
                  fullWidth
                  size="small"
                />
                <Box sx={{ position: "relative" }}>
                <span className="optinal-cls">Optional</span>
                <TextField
                  label="Discount Percentage"
                  fullWidth
                  size="small"
                />
                </Box>

                <TextField
                  label="Users Limit"
                  fullWidth
                  size="small"
                />

                <TextField
                  label="Warehouse Limit"
                  fullWidth
                  size="small"
                />


                <Grid container spacing={2}>
                  <Grid size={{ xs: 12, sm: 6 }}>
                    <TextField
                      label="Duration (Days)"
                      fullWidth
                      size="small"
                    />
                  </Grid>

                  <Grid size={{ xs: 12, sm: 6 }}>
                    <TextField
                      label="Status"
                      select
                      fullWidth
                      size="small"
                    >
                      <MenuItem value="Active">Active</MenuItem>
                      <MenuItem value="Inactive">Inactive</MenuItem>
                    </TextField>
                  </Grid>
                </Grid>

                <Button
                  className="st-btn-primary"
                >
                  Save
                </Button>
              </Box>
            </CardContent>
          </Card>
        </Grid>

        {/* ============== EXISTING PACKAGES ============== */}
        <Grid size={{ xs: 12, md: 7 }}>
          <Card className="st-card">
            <CardContent>
              <Typography component="div" className="st-h2">
                Existing Package
              </Typography>
              <Typography component="div" className="st-h3 st-muted">
                Search, Filter and update your current Package
              </Typography>

              {/* FILTERS */}
              <Box className="st-filter-row">
                <Grid container spacing={2}>
                    <Grid size={{ sm:7 }}>
                      <TextField
                        placeholder="Search By Package name, Tag"
                        fullWidth
                        size="small"
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <SearchIcon />
                            </InputAdornment>
                          ),
                        }}
                        className="cust-input-field"
                      />
                </Grid>
                  <Grid size={{ sm: 5 }}>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    value={statusFilter}
                    className="st-status-filter cust-input-field"
                    onChange={(e) => setStatusFilter(e.target.value)}
                    SelectProps={{
                      displayEmpty: true,
                      renderValue: (selected) => {
                        if (selected === "") {
                          return (
                            <span style={{ color: "#9e9e9e" }}>
                              Status Filter
                            </span>
                          );
                        }
                        return selected;
                      },
                    }}
                  >
                    <MenuItem value="">All</MenuItem>
                    <MenuItem value="Active">Active</MenuItem>
                    <MenuItem value="Inactive">Inactive</MenuItem>
                  </TextField>
                </Grid>
                </Grid>
              </Box>


                {/* PACKAGE LIST WITH SCROLL */}
                <Box
                  sx={{
                      maxHeight: {
                          lg: "457px",
                          xs: "447px",
                        },
                      overflowY: "auto",
                      pr: 1,               // space for scrollbar
                  }}
                >
                {filteredPackages.map((pkg) => (
                    <Box key={pkg.id} className="st-package-item">
                    {/* NAME + STATUS */}
                    <Box>
                        <Typography component="div" className="st-h2">
                        {pkg.name}
                        </Typography>

                        <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                        }}
                        >
                      <Box
                            component="img"
                            src="images/loading.png"
                            alt="edit"
                            sx={{
                              width: 22,
                              height: 22,
                              mt: "3px",   // ✅ works
                            }}
/>
                        <Typography component="div" className="st-h2">
                            {pkg.status}
                        </Typography>
                        </Box>
                    </Box>

                    {/* PRICE */}
                    <Box className="st-package-meta">
                        <Typography component="div" className="st-h2">
                        ${pkg.price}
                        </Typography>
                        <Typography component="div" className="st-strike">
                        ${pkg.originalPrice}
                        </Typography>
                        <span className="st-off">{pkg.discount}</span>
                    </Box>

                    {/* INFO */}
                    <Box className="st-package-info">
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <img
                          src="images/user1.png"
                          alt="edit"
                          width={18}
                          height={18}
                        />
                        <Typography>{pkg.users} Users</Typography>
                        </Box>

                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                         <img
                          src="images/residential.png"
                          alt="edit"
                          width={18}
                          height={18}
                        />
                        <Typography>{pkg.warehouses} Warehouse</Typography>
                        </Box>

                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                         <img
                          src="images/calendar1.png"
                          alt="edit"
                          width={18}
                          height={18}
                        />
                        <Typography>{pkg.duration} Days</Typography>
                        </Box>
                    </Box>

                    {/* ACTION */}
                    <Button
                        className="st-btn-edit"
                        onClick={() => console.log("Edit:", pkg)}
                    >
                        Edit
                    </Button>
                    </Box>
                ))}
                </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
}
